export default __webpack_public_path__ + "static/media/player-lauren-colour-desk.96f7d86c.png";